module.exports = __webpack_public_path__ + "img/location.e3504a71.png";